import { useEffect, useState } from 'react';
import { useThrottledCallback } from 'use-debounce';

import { getAssetTypeMaxCopyLength, shouldAssetCheckCopyLength } from 'src/data/asset';
import { MAX_WORDS_FOR_SCORE } from 'src/data/generation';
import { slateToText } from 'src/lib/slate';
import { countWords } from 'src/lib/string';

const CALC_INTERVAL = 300;
const DEFAULT_VALUE = {
  characters: 0,
  words: 0,
};

export const useContentCounterData = (assetType, content) => {
  const [counters, setCounters] = useState(DEFAULT_VALUE);

  const calcCharCount = useThrottledCallback((value) => {
    if (!value) {
      return;
    }

    const text = slateToText(value);
    setCounters({
      characters: text.length,
      words: countWords(text),
    });
  }, CALC_INTERVAL);

  useEffect(() => {
    calcCharCount(content);
  }, [calcCharCount, content]);

  const maxChars = getAssetTypeMaxCopyLength(assetType);
  const maxWords = MAX_WORDS_FOR_SCORE; // Always the same value for now

  // Counters should be highlighted either if text crosses "asset type" chars limit, or if it crosses global max words limit
  const isStrict = shouldAssetCheckCopyLength(assetType) || counters.words > maxWords;

  return {
    charsCount: counters.characters,
    wordsCount: counters.words,
    maxChars,
    maxWords,
    isStrict,
    isEmpty: counters.characters === 0,
  };
};
